import { STATUS } from "@/lib/calc";
import { Link } from "react-router-dom";
import { AlertTriangle, TrendingDown, Sparkles, ArrowRight } from "lucide-react";

const FlagsPanel = ({ digest, loading }) => {
  const flags = digest?.flags || [];
  const wins = digest?.wins || [];

  return (
    <div
      className="bg-white border border-[#E4DFD2] rounded-xl p-6"
      data-testid="flags-panel"
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="text-[11px] tracking-[0.08em] uppercase font-semibold text-[#69747C]">
            This week
          </div>
          <div className="font-display text-lg font-semibold text-[#1F2326]">
            What needs a look
          </div>
        </div>
        <div className="text-[10px] text-[#B89B5E] uppercase tracking-wider font-semibold">
          Digest
        </div>
      </div>

      {loading ? (
        <div className="text-sm text-[#69747C] py-4">Loading.</div>
      ) : flags.length === 0 ? (
        <div className="text-sm text-[#69747C] py-4 flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-[#6F9775]" />
          All retainers look on track this week.
        </div>
      ) : (
        <ul className="space-y-3" data-testid="flags-list">
          {flags.slice(0, 5).map((f) => {
            const s = STATUS[f.status] || STATUS.close_to_limit;
            return (
              <li key={f.id} data-testid={`flag-${f.id}`}>
                <Link
                  to={`/retainers/${f.id}`}
                  className="group flex items-start gap-3 rounded-lg border border-[#EDE7D6] px-3 py-2.5 hover:border-[#D6CFB9] hover:bg-[#FBFAF6] transition-colors"
                >
                  <div
                    className={`mt-0.5 w-7 h-7 rounded-full flex items-center justify-center flex-none ${s.bg} ${s.border} border`}
                  >
                    {f.status === "losing_money" ? (
                      <TrendingDown className={`w-3.5 h-3.5 ${s.text}`} />
                    ) : (
                      <AlertTriangle className={`w-3.5 h-3.5 ${s.text}`} />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-[#1F2326] truncate">
                      {f.name}
                    </div>
                    <div className="text-xs text-[#69747C] truncate">{f.reason}</div>
                  </div>
                  <ArrowRight className="w-4 h-4 text-[#C9C2B0] group-hover:text-[#69747C] transition-colors mt-1.5" />
                </Link>
              </li>
            );
          })}
        </ul>
      )}

      {wins.length > 0 ? (
        <div className="mt-5 pt-4 border-t border-[#EDE7D6]">
          <div className="text-[11px] tracking-[0.08em] uppercase font-semibold text-[#69747C] mb-2">
            Strongest retainers
          </div>
          <ul className="space-y-1.5" data-testid="wins-list">
            {wins.map((w) => (
              <li
                key={w.id}
                className="flex items-center justify-between text-sm"
              >
                <span className="text-[#1F2326] truncate">{w.name}</span>
                <span className="text-[#42624B] font-medium tabular-nums">
                  {w.margin?.toFixed(0)}% margin
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default FlagsPanel;
